import { getServices } from "../../../../api/getServices";
import { getStore } from "../../store/appStore";
import { setSchedule } from "../notebook";

/** Fetch schedule from backend and populate Redux. */
export const fetchSchedule = async () => {
  const state = getStore().getState();
  const kernelId = state.notebook.kernel;
  if (kernelId === null) {
    throw new Error("fetchSchedule requires kernelId.");
  }

  const response =
    await getServices().kernelsClient.kernelsService.getScheduledKernelSession({
      kernelId,
    });

  setSchedule(response.session ?? null);
};
